// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "1b4e8ca5af2b9874a9117cf6961690d0" + ".js";
};